<div class="flex h-full min-h-0 flex-col gap-4">
  <div class="relative mb-4">
    <div class="custom-form custom-form-readonly">
      <app-product-placement
        [form]="deliverableForm()"
        [creatorId]="executionAnalytics()?.creatorId"
        [isCustomMode]="true"
        [creators]="[]"
        [isViewMode]="true"
        [isExpanded]="true"
        [showStatusBadge]="executionAnalytics()?.status !== EMatchingType.planned"
        [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
        [analyticsObjective]="findingCards.objective()"
      />
    </div>
  </div>

  @if (manualDeliverableStatusConfig().analyticsVisible) {
    <div class="flex flex-col gap-3">
      <h3 class="text-sm font-bold">
        {{ 'pages.campaignDetails.ctaAnalytics.details.detected' | translate }}
        {{ 'pages.campaignDetails.ctaAnalytics.deliverable.' + deliverableType + '.title' | translate | lowercase }}
        @let summary = findingsSummary();
        @if (findingCards.loading()) {
          <ngx-skeleton-loader
            class="ml-2 inline-block h-3 align-middle"
            [theme]="{ height: '12px', width: '180px', margin: '0', 'border-radius': '4px', display: 'block' }"
          />
        } @else if (summary.count) {
          <span class="ml-2 text-xs font-normal text-shikenso-purple-base-60">
            {{
              (summary.count === 1
                ? 'pages.campaignDetails.ctaAnalytics.details.findingCards.summaryCountOne'
                : 'pages.campaignDetails.ctaAnalytics.details.findingCards.summaryCountOther'
              ) | translate: { count: summary.count }
            }}
            @if (summary.duration) {
              ·
              {{
                'pages.campaignDetails.ctaAnalytics.details.findingCards.summaryVisibleInTotal'
                  | translate: { duration: summary.duration }
              }}
            }
          </span>
        }
      </h3>

      <app-timeline-graph
        class="p-3 bg-shikenso-gray-base-24 rounded-2xl"
        [chartConfiguration]="chartConfiguration()"
        [startTimestamp]="0"
        [endTimestamp]="totalMediaDurationSeconds()"
        [findingSpans]="findingSpans()"
        (pointSelected)="onDataPointClick($event)"
      />
    </div>

    <app-finding-card-grid
      aspectRatio="3 / 4"
      [cards]="findingCards.sortedCards()"
      [(sortMode)]="findingCards.sortMode"
      [(selectedId)]="findingCards.highlightedId"
      [dimmedIds]="findingCards.pendingDeletionIds()"
      [loading]="findingCards.loading()"
      [canLoadImages]="findingCards.canLoadImages()"
      [imageCampaignExportId]="findingCards.imageCampaignExportId()"
      [numberColor]="findingColor()"
      [minCardWidth]="180"
      (openOnPlatform)="onRowClick($event.event, $event.card)"
    >
      <ng-template let-card>
        @let pendingDeletion = hasRowPendingDeletions(card);
        <app-finding-card-menu
          [pendingDeletion]="pendingDeletion"
          [busy]="pendingDeletion ? isVisualizerActing(card.id) : canDelete() && isFindingInFlight(card.id)"
          [deletable]="!!manualFindingStatusStore && canDelete()"
          (deleteFinding)="onDeleteSingleRowFinding(card)"
          (revertFinding)="onRevertRow(card)"
        />
      </ng-template>
    </app-finding-card-grid>

    @if (currentMedia() && shouldRenderInPagePlayer()) {
      <div class="w-full xl:max-w-[360px]" #mediaViewer>
        <app-post-media-viewer
          [media]="currentMedia()!"
          [videoConfiguration]="videoConfiguration()"
          [seekTime]="seekTime() ?? 0"
          [platformFeature]="executionAnalyticsWithFindings()?.platformFeature!"
        />
      </div>
    }
  }
</div>
